
export const CORP_FEATURES = [
    {display:'Convertible', value:'holdConvertible=Y'},
    {display:'Non-Convertible', value:'holdConvertible=N'}
]
.map(a => {
    a.label = a.display
    return a
})